// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PromotionsSponsorControlsTeenManageAuthorizationRequestInitiateEvent
 */
export var PromotionsSponsorControlsTeenManageAuthorizationRequestInitiate = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, productRequestToken = _a.productRequestToken, incentiveCampaignVariantToken = _a.incentiveCampaignVariantToken;
    return ({
        name: "PromotionsSponsorControls TeenManageAuthorizationRequest Initiate",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "TeenManageAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incentive_campaign_variant_token: incentiveCampaignVariantToken !== undefined && incentiveCampaignVariantToken !== null ? incentiveCampaignVariantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsTeenManageAuthorizationRequestResendEvent
 */
export var PromotionsSponsorControlsTeenManageAuthorizationRequestResend = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, productRequestToken = _a.productRequestToken;
    return ({
        name: "PromotionsSponsorControls TeenManageAuthorizationRequest Resend",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "TeenManageAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsTeenManageAuthorizationRequestCancelEvent
 */
export var PromotionsSponsorControlsTeenManageAuthorizationRequestCancel = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, productRequestToken = _a.productRequestToken;
    return ({
        name: "PromotionsSponsorControls TeenManageAuthorizationRequest Cancel",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "TeenManageAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsSponsorRespondToAuthorizationRequestApproveEvent
 */
export var PromotionsSponsorControlsSponsorRespondToAuthorizationRequestApprove = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, productRequestToken = _a.productRequestToken;
    return ({
        name: "PromotionsSponsorControls SponsorRespondToAuthorizationRequest Approve",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "SponsorRespondToAuthorizationRequest",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsSponsorRespondToAuthorizationRequestDeclineEvent
 */
export var PromotionsSponsorControlsSponsorRespondToAuthorizationRequestDecline = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, productRequestToken = _a.productRequestToken;
    return ({
        name: "PromotionsSponsorControls SponsorRespondToAuthorizationRequest Decline",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "SponsorRespondToAuthorizationRequest",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsSponsorDirectlyChangeControlEnableEvent
 */
export var PromotionsSponsorControlsSponsorDirectlyChangeControlEnable = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, productRequestToken = _a.productRequestToken;
    return ({
        name: "PromotionsSponsorControls SponsorDirectlyChangeControl Enable",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "SponsorDirectlyChangeControl",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            product_request_token: productRequestToken !== undefined && productRequestToken !== null ? productRequestToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsSponsorControlsSponsorDirectlyChangeControlDisableEvent
 */
export var PromotionsSponsorControlsSponsorDirectlyChangeControlDisable = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "PromotionsSponsorControls SponsorDirectlyChangeControl Disable",
        parameters: {
            cdf_entity: "PromotionsSponsorControls",
            cdf_action: "SponsorDirectlyChangeControl",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
